import React, { useCallback } from 'react'
import SegmentedOptionsGroup, { SegmentedOptionsGroupOnValueChangeHandler } from 'LuxKit/SegmentedOptions/SegmentedOptionsGroup'
import SegmentedOption from 'LuxKit/SegmentedOptions/SegmentedOption'

interface Props {
  value?: 'total' | 'perPerson'
  onChange?: (value: 'total' | 'perPerson') => void
}

function HotelPriceToggle({ value = 'total', onChange }: Props) {
  const handleChange = useCallback<SegmentedOptionsGroupOnValueChangeHandler>((newValue) => {
    onChange?.(newValue as 'total' | 'perPerson')
  }, [onChange])

  return (
    <form>
      <SegmentedOptionsGroup
        inputsName="hotelPriceMode"
        density="compact"
        onValueChange={handleChange}
      >
        <SegmentedOption
          checked={value === 'total'}
          value="total"
          title="Total price"
        />
        <SegmentedOption
          checked={value === 'perPerson'}
          value="perPerson"
          title="Per person"
        />
      </SegmentedOptionsGroup>
    </form>
  )
}

export default HotelPriceToggle
